module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Shift-432bb3a2a207bd0ba84266cb1f913f5a063198278c4ddeb78cb4ee64559bf783.svg";